import { useQuery } from '@tanstack/react-query'

import { caseAddDeleteHistoryQuery } from '@/lib/queries/business/v1/case/logs/queries'

export const useCaseActivityHistory = () => {
  const { data: queryResult, isLoading: isLoadingData } = useQuery(
    caseAddDeleteHistoryQuery({ pageNumber: 1, pageSize: 999 })
  )

  const caseAddDeleteHistoryData = queryResult?.results ?? []

  return { caseAddDeleteHistoryData, isLoadingData }
}
